// Main API service that dynamically loads the correct implementation based on API_MODE
import { apiConfig } from './apiConfig';

// Dynamic API loading based on configuration
let apiImplementation = null;

const loadAPI = async () => {
  if (apiImplementation) {
    return apiImplementation;
  }

  console.log(`🔧 Loading ${apiConfig.mode} API implementation...`);

  try {
    switch (apiConfig.mode) {
      case 'firestore':
        apiImplementation = await import('./firestoreAPI');
        break;
      case 'local':
      default:
        apiImplementation = await import('./localAPI');
        break;
    }

    console.log(`✅ ${apiConfig.mode} API loaded successfully`);
    return apiImplementation;
  } catch (error) {
    console.error(`❌ Failed to load ${apiConfig.mode} API:`, error);
    // Fallback to local API if loading fails
    console.log('🔄 Falling back to local API...');
    apiImplementation = await import('./localAPI');
    return apiImplementation;
  }
};

// Create proxy functions that load the correct API implementation
const createAPIProxy = (apiName) => {
  return new Proxy({}, {
    get: function(_, prop) {
      return async function(...args) {
        const api = await loadAPI();
        const apiModule = api[apiName];
        
        if (!apiModule || typeof apiModule[prop] !== 'function') {
          throw new Error(`API method ${apiName}.${prop} not found in ${apiConfig.mode} implementation`);
        }
        
        return apiModule[prop](...args);
      };
    }
  });
};



// Export API proxies
export const blogAPI = createAPIProxy('blogAPI');
export const contactAPI = createAPIProxy('contactAPI');



// Export API configuration for components that need it
export { apiConfig };



// Default export
export default {
  blogAPI,
  contactAPI,
  apiConfig
};
